import React, { useContext } from 'react';
import './CheckBoxes.module.scss';
import { SchoolsContext } from 'screens/Schools/Schools';
import CheckBox from 'components/UI/Checkbox/CheckBox';

export default function CheckBoxes() {
    const { checkedLabels, setCheckedLabels, checkboxesLabels } = useContext(
        SchoolsContext
    );

    const handleCheckboxChange = (label) => {
        if (checkedLabels.includes(label)) {
            setCheckedLabels(checkedLabels.filter((item) => item !== label));
        } else {
            setCheckedLabels([...checkedLabels, label]);
        }
    };

    return (
        <div styleName="checkboxes">
            {checkboxesLabels.map((label, index) => (
                <CheckBox
                    blueGray
                    key={index}
                    checked={checkedLabels.includes(label)}
                    onClick={() => handleCheckboxChange(label)}
                >
                    {label}
                </CheckBox>
            ))}
        </div>
    );
}
